import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { SharedService } from "../shared.service";

export interface InventoryDashboardReportRequest {
  compId: number;
  fromDt?: string | null;
  toDt?: string | null;
  productId?: number | null;
  state?: string | null;
  /** Free-text match against product name/SKU - sent so the backend can
   *  filter server-side once USP_GetInventoryDashboardReport accepts it;
   *  ignored harmlessly by ASP.NET model binding until then. */
  search?: string | null;
  pageNo?: number;
  pageSize?: number;
}

export interface InventoryDashboardKpi {
  metricKey: string;
  metricValue: string;
  percentChange: number;
  /** Raw "{0,4,10,}" trend string off the SP - parse with parseTrendGraph() from qr-lifecycle.service.ts */
  graphData: string;
}

export interface InventoryDashboardReportItem {
  productId: number;
  productName: string;
  sku: string;
  qrBalance: number;
  consumedQty: number;
  dailyRunRate: number;
  avgDailyConsumption: number;
  reorderLevel: number;
  stockCover: number;
  status: string;
  remainingQty: number;
  statusColor: string;
}

export interface InventoryDashboardReportResponse {
  kpi: InventoryDashboardKpi[];
  data: InventoryDashboardReportItem[];
  pageNo: number;
  pageSize: number;
  totalRecords: number;
  totalPages: number;
}

interface ApiResponse<T> {
  responseCode: string;
  responseMessage: string;
  details: T;
  errorDetails?: string;
}

@Injectable({ providedIn: "root" })
export class InventoryReportService {
  url;

  constructor(private http: HttpClient, private sharedService: SharedService) {
    this.url = sharedService.baseURL;
  }

  getDashboard(
    request: InventoryDashboardReportRequest,
  ): Observable<InventoryDashboardReportResponse> {
    return this.http
      .post<ApiResponse<InventoryDashboardReportResponse>>(
        `${this.url}/api/Home/InventoryDashboardReport`,
        request,
      )
      .pipe(map((res) => res.details));
  }
}
